import React from "react";
import { components } from "react-select";
import BrokerAvatar from "../mui/material/BrokerAvatar";
var BrokerSingleValue = function BrokerSingleValue(props) {
  return /*#__PURE__*/React.createElement(components.SingleValue, props, props.data.value && /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement(BrokerAvatar, {
    size: "sm",
    broker: props.data
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 ps-2"
  }, props.data.label)));
};
export default BrokerSingleValue;